import axios from "axios";
export const baseURL = 'https://api.wingdrive.com.co/api/v1';

export const api = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 1200000, 
});

// Interceptor para agregar token automáticamente
api.interceptors.request.use((config: any) => {
  const token = localStorage.getItem("accessToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
